import Accordion from '@/ReactInit/Scripts/Accordion/Accordion';
import AddRating from '@/ReactInit/Scripts/RecipePage/AddRating';
import CopyUrlButton from '@/ReactInit/Scripts/CopyUrlButton/CopyUrlButton';
import Newsletter from '@/ReactInit/Scripts/Newsletter/Newsletter'
import Navbar from '@/ReactInit/Scripts/Navbar/Navbar'
import SeasonCalendar from '@/ReactInit/Scripts/SeasonCalendar/SeasonCalendar'
import WeekMenuCarousel from '@/ReactInit/Scripts/WeekMenuCarousel/WeekMenuCarousel'
import Search from '@/ReactInit/Scripts/SearchPage/search';
// import ReactTest from '@/ReactInit/Scripts/ReactTest/ReactTest';
import RecipeFeedbackForm from './Scripts/RecipePage/FeedbackForm';
import RecipePageStarRatingStatic from '@/ReactInit/Scripts/RecipePage/StarRatingStatic';
import RecipeIngredients from '@/ReactInit/Scripts/RecipePage/RecipeIngredients';
import VideoList from '@/ReactInit/Scripts/VideoPlayer/video';

import '@/ReactInit/Scripts/Factblock'

export default {
  AddRating,
  CopyUrlButton,
  Newsletter,
  Navbar,
  Accordion,
  WeekMenuCarousel,
  SeasonCalendar,
  RecipeFeedbackForm,
  RecipePageStarRatingStatic,
  RecipeIngredients,
  Search,
  VideoList,
};
